export interface WorkItem {
  id: string;
  title: string;
  cover: string;
  type: '电影' | '电视剧';
  year: number;
  role: string;
  intro: string;
  rating: number;
}

export const worksList: WorkItem[] = [
  {
    id: 'work-001',
    title: '花都浮梦',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20style%20portrait%20of%20elegant%20asian%20actress%20in%20traditional%20inspired%20dress%2C%20dramatic%20navy%20and%20gold%20lighting%2C%20film%20poster%20composition&width=600&height=800&seq=work001-01&orientation=portrait',
    type: '电影',
    year: 2026,
    role: '饰 林晚秋',
    intro: '讲述一位都市女性在事业与家庭之间寻找自我的温情故事，张柏芝饰演坚韧独立的女主角。',
    rating: 8.6,
  },
  {
    id: 'work-002',
    title: '长河入海',
    cover: 'https://readdy.ai/api/search-image?query=dramatic%20tv%20series%20poster%20portrait%20asian%20actress%20standing%20by%20river%20at%20dusk%2C%20cinematic%20navy%20blue%20tones%2C%20moody%20atmosphere%2C%20professional%20poster%20photography&width=600&height=800&seq=work002-01&orientation=portrait',
    type: '电视剧',
    year: 2025,
    role: '饰 苏云舒',
    intro: '以家族商战为背景的年代大戏，张柏芝饰演精明果敢的女商人，展现跌宕起伏的命运转折。',
    rating: 8.3,
  },
  {
    id: 'work-003',
    title: '光影之间',
    cover: 'https://readdy.ai/api/search-image?query=artistic%20film%20poster%20portrait%20of%20asian%20actress%20in%20soft%20studio%20light%2C%20warm%20orange%20and%20deep%20navy%20contrast%2C%20elegant%20cinematic%20style&width=600&height=800&seq=work003-01&orientation=portrait',
    type: '电影',
    year: 2024,
    role: '饰 顾清霜',
    intro: '一部聚焦演艺圈幕后故事的剧情片，张柏芝以细腻演技诠释一位历经沉浮的资深演员。',
    rating: 8.9,
  },
  {
    id: 'work-004',
    title: '岁月留声',
    cover: 'https://readdy.ai/api/search-image?query=nostalgic%20tv%20drama%20poster%20asian%20actress%20in%20vintage%20styled%20outfit%2C%20warm%20sepia%20and%20navy%20tones%2C%20cinematic%20poster%20composition&width=600&height=800&seq=work004-01&orientation=portrait',
    type: '电视剧',
    year: 2023,
    role: '饰 周雅琴',
    intro: '横跨三十年的家庭年代剧，张柏芝饰演的女主角见证了时代变迁与亲情羁绊。',
    rating: 8.1,
  },
  {
    id: 'work-005',
    title: '都市晴空',
    cover: 'https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20asian%20actress%20in%20business%20attire%20city%20skyline%20background%2C%20cool%20navy%20tones%2C%20editorial%20poster%20style&width=600&height=800&seq=work005-01&orientation=portrait',
    type: '电视剧',
    year: 2022,
    role: '饰 陆晓曼',
    intro: '都市职场题材剧集，张柏芝饰演干练的职场女性，在挑战中不断成长。',
    rating: 7.9,
  },
  {
    id: 'work-006',
    title: '海上繁星',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20film%20poster%20asian%20actress%20by%20the%20ocean%20at%20night%20with%20starlight%2C%20navy%20blue%20and%20warm%20gold%20accent%2C%20cinematic%20composition&width=600&height=800&seq=work006-01&orientation=portrait',
    type: '电影',
    year: 2021,
    role: '饰 林星辰',
    intro: '一段跨越时间的爱情故事，张柏芝细腻演绎角色在聚散离合中的成长与释然。',
    rating: 8.4,
  },
];